
let currentSlide = 0;
const slides = document.querySelectorAll('.hero-slide');
const dots = document.querySelectorAll('.dot-nav');
const AUTOPLAY_MS = 8000;
let autoplayTimer = null;

function showSlide(n) {
  if (slides.length === 0) return;

  slides.forEach(slide => slide.classList.remove('active'));
  dots.forEach(dot => {
    dot.classList.remove('active');
    dot.setAttribute('aria-selected', 'false');
  });

  currentSlide = (n + slides.length) % slides.length;

  slides[currentSlide].classList.add('active');
  if (dots[currentSlide]) {
    dots[currentSlide].classList.add('active');
    dots[currentSlide].setAttribute('aria-selected', 'true');
  }
}

function changeSlide(direction) {
  showSlide(currentSlide + direction);
  restartAutoplay();
}

function goToSlide(n) {
  showSlide(n);
  restartAutoplay();
}

// Auto-advance — but only while the tab is visible, to avoid background
// timers draining battery / waking the CPU when the user isn't looking.
function startAutoplay() {
  if (autoplayTimer || slides.length < 2 || document.hidden) return;
  autoplayTimer = setInterval(() => changeSlide(1), AUTOPLAY_MS);
}

function stopAutoplay() {
  if (autoplayTimer) {
    clearInterval(autoplayTimer);
    autoplayTimer = null;
  }
}

function restartAutoplay() {
  stopAutoplay();
  startAutoplay();
}

document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    stopAutoplay();
  } else {
    startAutoplay();
  }
});

startAutoplay();
